import { IFetchObject } from "../../data/actions.interface"
import { ICreateReportDto, IModifyReportDto } from "./report.dto"

export const getReports = (): IFetchObject => ({
    key: 'report',
    url: 'customer/report',
    method: 'GET',
    default: {},
})


export const getReport = (customerId: string, id: number): IFetchObject => ({
    key: `get-customer-report/${id}`,
    url: `customer-reports/customerId/${customerId}/report/${id}`,
    method: 'GET',
    default: [],
    
})

export const createReport = (id: number, addReportDto: ICreateReportDto): IFetchObject => ({
    key: `add-customer-report`,
    url: `customer-reports/${id}`,
    method: 'POST',
    default: [],
    body: addReportDto,
})

export const deleteReport = (customerId: string,id: number): IFetchObject => ({
    key: `delete-customer-report`,
    url: `customer-reports/customerId/${customerId}/report/${id}`,
    method: 'DELETE',
    default: [],

})
export const modifyReport = (customerId: string, modifyReport: IModifyReportDto): IFetchObject => ({
    key: `modify-customer-report`,
    url: `customer-reports/${customerId}`,
    method: 'PUT',
    default: [],
    body: modifyReport,
})